import new_file from "frontend/files/make/new_file"
import get_media_urls from "frontend/files/naming/get_media_urls"
import guess_filename from "frontend/files/naming/guess_filename"
import make_from_filedata from "frontend/files/naming/make_from_filedata"
import split_filename from "frontend/files/naming/split_filename"
import merge from "rfuncs/functions/merge"
import { FILE_NOT_FOUND } from "translations/enum/errors"
import get_url_head from "workflow/requests/get_url_head"
import tracking from "workflow/state/tracking"
import hash from "workflow/utils/hash"

const get_first_url = async (emit, urls, suggested_type, suggested_name) => {
  for (const url of urls) {
    try {
      const {
        name,
        content_type: type,
        status,
      } = await get_url_head(
        url,
        emit,
        { cache: "force-cache" },
        suggested_type,
        suggested_name
      )

      if (status < 300) {
        return { url, name, type }
      }
    } catch (error) {
      console.info("Error fetching URL:", url, error)
    }
  }

  throw FILE_NOT_FOUND
}

export default ({ remote_id, remote_name, folder, type, id }) => {
  const name = make_from_filedata(
    merge(split_filename(guess_filename(remote_name)), {
      folder,
    })
  )

  return new_file({
    id: id || `remote-${hash(remote_id)}`,
    name: name,
    factory: f =>
      tracking.track_promise(emit =>
        get_first_url(emit, get_media_urls(remote_id), type, name)
      ),
    remote_id,
    type,
  })
}
